<a *ngIf="shouldShowTooltip" placement="{{placement}}" ngbTooltip="{{tooltipMsg}}">
  <svg [ngStyle]="{'width': width+ 'px', 'height': height + 'px'}" viewBox="0 0 9 9" version="1.1"
       xmlns="http://www.w3.org/2000/svg"
       class="icon-tooltip">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Discover---Tooltip" transform="translate(-249.000000, -392.000000)" fill="#717D8D" fill-rule="nonzero">
        <g id="bx-info-circle-copy" transform="translate(249.010417, 392.013542)">
          <path d="M4.26875,0 C1.91496125,0 0,1.91496125 0,4.26875 C0,6.62253875 1.91496125,8.5375 4.26875,8.5375 C6.62253875,8.5375 8.5375,6.62253875 8.5375,4.26875 C8.5375,1.91496125 6.62253875,0 4.26875,0 Z M4.26875,7.68375 C2.38580438,7.68375 0.85375,6.15169563 0.85375,4.26875 C0.85375,2.38580437 2.38580438,0.85375 4.26875,0.85375 C6.15169563,0.85375 7.68375,2.38580438 7.68375,4.26875 C7.68375,6.15169563 6.15169563,7.68375 4.26875,7.68375 Z" id="Shape"></path>
          <path d="M3.841875,3.841875 L4.695625,3.841875 L4.695625,6.403125 L3.841875,6.403125 L3.841875,3.841875 Z M3.841875,2.134375 L4.695625,2.134375 L4.695625,2.988125 L3.841875,2.988125 L3.841875,2.134375 Z" id="Shape"></path>
        </g>
      </g>
    </g>
  </svg>
</a>



// WEBPACK FOOTER //
// ./src/app/core/achoo-icon-tooltip/achoo-icon-tooltip.component.html